import './instrument' // Sentry — must be first so boot-time errors are captured
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { initAnalytics } from './lib/analytics'

// The storefront lives only at getdub.com/merch. Bounce to the apex host,
// path preserved, for (a) anything on the retired shop.getdub.com subdomain
// and (b) merch paths that land on the app host — this same app serves every
// shop-era route there (including the legacy /store and /products/:handle
// redirects in App.jsx).
const { hostname, pathname, search, hash } = window.location
if (
  hostname === 'shop.getdub.com' ||
  (hostname === 'app.getdub.com' && (pathname.startsWith('/merch') || pathname.startsWith('/store')))
) {
  window.location.replace(`https://getdub.com${pathname}${search}${hash}`)
}

initAnalytics()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
